const products = [
  {
    id: "vpn",
    tag: "Privacy & Security",
    name: "ROXTVEL VPN",
    description:
      "Advanced VPN solution engineered for iOS, delivering military-grade encryption and anonymous browsing. Protect your data on any network with zero-log policy and blazing-fast global servers.",
    features: ["AES-256 Encryption", "Zero-Log Policy", "Global Server Network", "Kill Switch Protection"],
    icon: "ri-shield-keyhole-line",
    accent: "#1A3A2E",
    accentLight: "#E8F5F0",
    img: "https://public.readdy.ai/ai/img_res/7160735e847e32f2c743c0f875f27c5c.jpg",
  },
  {
    id: "cleaner",
    tag: "Performance",
    name: "ROXTVEL Cleaner",
    description:
      "Intelligent iOS cleaner that reclaims storage space and optimizes device performance. Smart scanning technology identifies junk files, duplicate media, and cached data to keep your iPhone running at peak speed.",
    features: ["Smart Junk Scanner", "Duplicate Remover", "Cache Cleaner", "Battery Optimizer"],
    icon: "ri-speed-up-line",
    accent: "#3A2A1A",
    accentLight: "#FFF3E8",
    img: "https://readdy.ai/api/search-image?query=sleek%20iPhone%20mockup%20displaying%20a%20minimalist%20phone%20cleaner%20app%20interface%20with%20performance%20gauge%20and%20optimization%20icons%20warm%20amber%20accent%20colors%20clean%20modern%20UI%20typography%20on%20pure%20white%20background%20product%20photography%20style%20sharp%20clean%20no%20background%20distractions&width=600&height=700&seq=cleaner04&orientation=portrait",
  },
];

export default function ProductsSection() {
  return (
    <section id="products" className="w-full py-28" style={{ background: "#FAF9F7" }}>
      <div className="max-w-7xl mx-auto px-10">
        {/* Header */}
        <p className="text-xs uppercase tracking-widest text-gray-400 font-medium mb-4">
          &bull;&nbsp; Our Solutions
        </p>
        <div className="flex flex-col md:flex-row md:items-end md:justify-between mb-16 gap-4">
          <h2 className="text-4xl md:text-5xl font-bold text-[#1A1A1A] leading-tight" style={{ fontFamily: "'Inter', sans-serif" }}>
            VPN &amp; Cleaner
            <br />
            <span className="text-gray-400 font-normal text-3xl md:text-4xl">Built for iOS Excellence</span>
          </h2>
          <p className="text-gray-500 text-sm max-w-xs leading-relaxed">
            Two flagship applications designed to deliver a safer, faster, and more private iOS experience.
          </p>
        </div>

        {/* Product cards */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
          {products.map((product) => (
            <article
              key={product.id}
              className="bg-white rounded-2xl overflow-hidden flex flex-col"
            >
              {/* Image area */}
              <div
                className="relative w-full flex items-center justify-center py-10 px-8"
                style={{ background: product.accentLight, minHeight: 300 }}
              >
                {/* Icon badge */}
                <div
                  className="absolute top-5 left-5 flex items-center gap-2 px-3 py-1.5 rounded-full text-xs font-semibold text-white"
                  style={{ background: product.accent }}
                >
                  <span className={`${product.icon} text-sm w-4 h-4 flex items-center justify-center`}>
                    <i className={product.icon} />
                  </span>
                  {product.tag}
                </div>
                <img
                  src={product.img}
                  alt={`${product.name} app screenshot`}
                  className="h-64 w-auto object-contain object-top"
                />
              </div>

              {/* Content area */}
              <div className="p-8 flex flex-col flex-1">
                <h3 className="text-2xl font-bold text-[#1A1A1A] mb-3" style={{ fontFamily: "'Inter', sans-serif" }}>
                  {product.name}
                </h3>
                <p className="text-gray-500 text-sm leading-relaxed mb-6">{product.description}</p>

                {/* Feature pills */}
                <div className="flex flex-wrap gap-2 mt-auto">
                  {product.features.map((f) => (
                    <span
                      key={f}
                      className="px-3 py-1.5 rounded-full text-xs font-medium border border-gray-200 text-gray-600 bg-[#F7F7F7]"
                    >
                      {f}
                    </span>
                  ))}
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
